import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-menu-children-add-edit',
  templateUrl: './menu-children-add-edit.component.html',
  styleUrls: ['./menu-children-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class MenuChildrenAddEditComponent implements OnInit, OnDestroy {

  menuForm!: FormGroup;
  menuList: any = [];
  adminMenuId: any;
  menuDetails: any;
  isSubmitTypeAdd!: boolean ;
  parentId:any;
  ngUnsubscribe = new Subject<void>();
  constructor(
    public apiService: ApiService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    public location: Location
    ) { }

  ngOnInit(): void {
    this.formInit();
    this.adminMenuId = this.activatedRoute.snapshot.params["id"];
    if(this.adminMenuId){
      this.getAdminDetails();
    }
    this.isSubmitTypeAdd = this.router.url.startsWith('/settings/menu/menu-children-add');
    if(!this.isSubmitTypeAdd){
      this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
        this.parentId = res?.parentId;
        this.getParentDetails();
      })
    }
    // this.getAllMenuList();
  }

  formInit(){
    this.menuForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      parentId: new FormControl(''),
      description: new FormControl('', ),
      frontendComponentName: new FormControl('', [Validators.required]),
      backendComponentName: new FormControl('', [Validators.required]),
      isActive: new FormControl('', [Validators.required]),
    })
  }
  getAllMenuList(){
    this.apiService
      .get(`${endpoints.settings.menuManagement.getAllMenuList}?page=1&size=99999`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res : any)=>{
        if(res?.body?.adminMenus){
          this.menuList = res?.body?.adminMenus?.data;
        }
      })
  };
  getParentDetails(){
    this.apiService.get(endpoints.settings.menuManagement.getParentMenuDetails(this.adminMenuId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res?.body?.adminMenus){
        this.menuList = res?.body?.adminMenus;
      }
    })
  }
  getAdminDetails(){
    this.apiService.get(endpoints.settings.menuManagement.getMenuDetails(this.adminMenuId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res : any)=>{
      if(res?.body){
        this.menuDetails = res?.body?.adminMenu;
        if(this.isSubmitTypeAdd){
          this.menuList = res?.body?.adminMenu?.children;
        }
        
        if(!this.router.url.startsWith('/settings/menu/menu-children-add')){
          this.menuForm.patchValue(res?.body?.adminMenu);  
          this.menuForm.patchValue({
            parentId: this.parentId
          });
        } 
        
      }
    })
  }

  addEditMenu(){
    if(this.menuForm.valid){
      if(this.isSubmitTypeAdd){
        this.apiService.post(endpoints.settings.menuManagement.createMenu, this.menuForm.value).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      } else {
        this.apiService.patch(endpoints.settings.menuManagement.updateMenu(this.adminMenuId), this.menuForm.value).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res : any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      }
      
    } else {
      this.menuForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
